function WaiverFormPage(){
    return(
        <div>
            <a href='https://remai.jdfasia.com/downloads/waiver-form.pdf'>Click here to download waiver form.</a>
        </div>
    );
}

export default WaiverFormPage;